@if (vm) {
  <ng-template #appointmentTooltip>
    <lib-schedule-calendar-item-tooltip [vm]="vm"></lib-schedule-calendar-item-tooltip>
  </ng-template>
  @if (isMyDay) {
    <div
      class="relative h-full w-full"
      [libUiTooltip]="isNudgeActive ? undefined : appointmentTooltip"
      [tooltipDelay]="500"
      tooltipPosition="right"
      [coverHeader]="true"
    >
      <div class="h-full w-full bg-background-white"></div>
      <div class="absolute left-0 top-0 z-10 h-full w-full opacity-50" [style.background]="vm.color"></div>
      <div class="typo-h7-semibold absolute left-0 top-0 z-20 h-full w-full overflow-hidden overflow-ellipsis whitespace-nowrap p-2">
        {{ vm.operatoryName }}
      </div>
    </div>
  } @else {
    <div
      class="relative grid h-full grid-cols-[8px_1fr] bg-background-light-blue @container-size"
      [ngClass]="{
        ' bg-background-white': isNewAppointmentItem || vm.isTentative
      }"
      [libUiTooltip]="isNudgeActive ? undefined : appointmentTooltip"
      [tooltipDelay]="500"
      [coverHeader]="true"
      [tooltipPosition]="['top-left', 'bottom-left', 'left']"
      [cdkContextMenuTriggerFor]="isNewAppointmentItem ? null : contextMenuRef?.appointmentContextMenu"
      (contextmenu)="onRightClick()"
    >
      <div class="relative isolate grid h-full" [style.gridTemplateRows]="'repeat(' + vm.timePattern.length + ', 1fr)'">
        <div class="stripes absolute z-0 h-full w-full" [style.background]="vm.color"></div>

        @if (vm.isTentative) {
          <div class="h-full w-full"></div>
        } @else {
          @for (el of vm.timePattern; track $index) {
            @switch (el) {
              @case (AppointmentTimePattern.PROVIDER) {
                <div class="z-10 h-full w-full" [style.background]="vm.color"></div>
              }
              @case (AppointmentTimePattern.CHAIR) {
                <div class="z-10 h-full w-full bg-background-white">
                  <div
                    class="z-10 h-full w-full"
                    [ngClass]="{
                      'bg-background-white': isNewAppointmentItem,
                      'bg-background-light-blue': !isNewAppointmentItem
                    }"
                  ></div>
                </div>
              }
              @case (AppointmentTimePattern.ASSISTANT) {
                <div class="h-full w-full"></div>
              }
            }
          }
        }
      </div>
      <div
        class="flex gap-[2px] overflow-hidden bg-background-light-blue p-[2px] text-text-primary @container-size"
        [ngClass]="{
          '!bg-background-white': isNewAppointmentItem || vm.isTentative
        }"
        [style.borderColor]="vm.color"
      >
        <div class="h-[22px] w-[4px] flex-shrink-0 rounded-[1px]" [style.background-color]="getStatusColorHex()"></div>
        <div class="invisible relative flex h-full grow flex-col gap-1 overflow-hidden py-1 @h-[16px]:visible">
          <div class="gap-1 @h-[40px]:flex-col @h-[40px]:gap-0">
            @if (vm.isTentative) {
              <div class="typo-h7-light">({{ 'schedule_calendar_tentative' | translate }})</div>
            }

            <div class="typo-h8-semibold @w-[22px]:hidden">...</div>

            @if (!hidePatientNameSignal()) {
              <div class="flex flex-1 justify-between gap-1">
                <div class="typo-h8-semibold invisible truncate @w-[22px]:visible">
                  {{ vm.patientName }}
                </div>
              </div>
            }
          </div>

          @if (!isCompactViewSignal()) {
            <div class="flex flex-1 flex-col justify-between">
              <div>
                <div class="flex items-center text-h8">
                  <span class="truncate">{{ vm.from | timeRangeFormat: vm.to }}</span>
                </div>
                <div class="flex flex-col text-h8">
                  <div class="hidden overflow-hidden overflow-ellipsis whitespace-nowrap @h-[48px]:inline">
                    {{ vm.pmsProviderId }}@if (vm.secondaryPmsProviderId) {, {{ vm.secondaryPmsProviderId }}}
                  </div>
                  <div class="hidden overflow-hidden overflow-ellipsis @h-[56px]:line-clamp-1">
                    {{ vm.reason }}
                  </div>
                </div>
              </div>
              <div class="hidden items-center @h-[80px]:flex">
                @if (vm.notes.length > 0) {
                  <svg-icon class="shrink-0 rounded-full text-text-light" key="px-12-template" size="xs" />
                }
                @if (vm.isProvisional && !isShowcase && this.displayHourglass) {
                  <div class="ml-auto flex items-center">
                    <svg-icon
                      class="shrink-0 rounded-full text-text-light"
                      key="px-12-hourglass"
                      size="xs"
                      [libUiTooltip]="provisionalTooltip"
                      tooltipPosition="bottom"
                    />
                    <ng-template #provisionalTooltip>
                      <div class="typo-h7-light p-2">
                        {{ 'schedule_provisional_appointment_tooltip' | translate }}
                      </div>
                    </ng-template>
                  </div>
                }
              </div>
            </div>
          }
        </div>
        @if (!vm.isPreRegistrationAppointment && (vm.patientAlerts?.length ?? 0) > 0) {
          @if (isCompactViewSignal()) {
            <div class="flex h-1 w-1 shrink-0 rounded-full bg-states-orange"></div>
          } @else {
            <div class="w-[6px] @w-[96px]:w-[14px]">
              <div class="flex h-[14px] items-center pt-[4px]">
                <svg-icon class="!hidden shrink-0 text-states-orange @w-[96px]:!flex" key="px-16-patient-alert" size="xs" />
                <div class="flex h-[6px] w-[6px] shrink-0 rounded-full bg-states-orange pt-[6px] @w-[96px]:hidden"></div>
              </div>
            </div>
          }
        }
        @if (!vm.isPreRegistrationAppointment && (vm.medicalAlerts?.length ?? 0) > 0) {
          @if (isCompactViewSignal()) {
            <div class="flex h-1 w-1 shrink-0 rounded-full bg-states-red"></div>
          } @else {
            <div class="w-[6px] @w-[96px]:w-[14px]">
              <div class="flex h-[14px] items-center pt-[4px]">
                <svg-icon class="!hidden shrink-0 text-states-deep-red @w-[96px]:!flex" key="px-16-medical-alert" size="xs" />
                <div class="flex h-[6px] w-[6px] shrink-0 rounded-full bg-states-red pt-[6px] @w-[96px]:hidden"></div>
              </div>
            </div>
          }
        }
      </div>
      @if (isCompleted) {
        <div class="absolute left-0 top-0 z-50 h-full w-full bg-background-white" [style.opacity]="0.76"></div>
      }
    </div>
  }
  <svg-icon size="sm" [key]="'px-24-exposure'"></svg-icon>

  <!-- Context Menu Component -->
  <lib-appointment-context-menu
    #contextMenuRef
    [vm]="vm"
    [statusOptions]="statusOptions"
    [areTreatmentsLoaded]="areTreatmentsLoaded"
    (setComplete)="onSetComplete()"
    (editStatus)="onEditStatus()"
    (editAppointment)="onEditAppointment()"
    (deleteAppointment)="onDeleteAppointment()"
    (openHealthHistory)="onOpenHealthHistory()"
    (changeStatus)="onChangeStatus($event)"
  />
}
